var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { PlanTypeCategory } from '../../enum';
import { useTerminologyTranslation } from '../app/terminology';
import { SubTitle } from '../layout/styled';
import { getWorkflowSteps } from './constants';
import { usePlanType, usePlanTypeCategory, useWizardParams } from './selectors';
export var Description = function () {
    var t = useTerminologyTranslation('wizard').t;
    var _a = useWizardParams(), stepIndex = _a.stepIndex, stepName = _a.stepName;
    var planType = usePlanType();
    var planTypeCategory = usePlanTypeCategory();
    var totalSteps = getWorkflowSteps(planTypeCategory).length;
    var description = (function () {
        // Use prod hours description when plan is prod hours
        var key = planTypeCategory === PlanTypeCategory.ProdHours && ['supportStaff', 'workingDay'].includes(stepName)
            ? "".concat(stepName, ".descriptionProdHours")
            : "".concat(stepName, ".description");
        return t(key, { planType: planType });
    })();
    return (_jsxs(_Fragment, { children: [_jsxs(Typography, __assign({ variant: "h1" }, { children: [t('message.stepCount', { index: stepIndex + 1, total: totalSteps }), t("".concat(stepName, ".fullName"))] })), _jsx(Stack, __assign({ flexDirection: "row", alignItems: "center", sx: { gap: 3, mt: 5 } }, { children: _jsx(SubTitle, __assign({ sx: { flex: 1 } }, { children: description })) }))] }));
};
